import type { Attachment, AttachmentKind } from '../../types/portal'

/**
 * Las reglas del adjunto del chat, sin React: cuáles se muestran solos, de
 * dónde se pide la URL y cómo se escribe el peso. Viven aparte para correrlas
 * en Node (`tests/unit/test_adjuntos_como_whatsapp.py`); `Adjunto.tsx` las
 * cablea.
 */

/** Lo que se muestra adentro de la burbuja sin tocar nada: la foto, el
 *  sticker, el reproductor y la primera hoja del PDF. El resto es una tarjeta
 *  que abre el visor. */
const SE_MUESTRAN_SOLOS: ReadonlySet<string> = new Set(['image', 'sticker', 'audio', 'video', 'pdf'])

export function seCargaSola(kind: AttachmentKind | string): boolean {
  return SE_MUESTRAN_SOLOS.has(kind)
}

/**
 * De dónde se pide lo que se muestra en la burbuja.
 *
 * - PDF: la miniatura (`/documents/{id}/miniatura`), no el archivo entero.
 * - Lo que trae `preview_path`: la media que no es un documento
 *   (`/conversations/{id}/media?m=…`) y, desde el backend, todo lo demás.
 * - Lo que solo trae `doc_id`: su vista previa.
 *
 * `''` si todavía no hay nada que pedir: un archivo que se está procesando.
 */
export function rutaDeVista(a: Pick<Attachment, 'kind' | 'doc_id' | 'preview_path'>): string {
  if (a.kind === 'pdf') {
    return a.doc_id ? `/documents/${encodeURIComponent(a.doc_id)}/miniatura` : ''
  }
  if (a.preview_path) return a.preview_path
  if (a.doc_id) return `/documents/${encodeURIComponent(a.doc_id)}/preview`
  return ''
}

/** «718 kB», «1,2 MB», como lo escribe WhatsApp en español. */
export function pesoLegible(bytes: number): string {
  if (!bytes || bytes < 0) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} kB`
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`
}
